import Ajax from "Utils/ajax";
export const getHelpContentByPageURL = (data) => Ajax.post('admin/getHelpContentByPageURL',data);